import { render, staticRenderFns } from "./sales-order-dashboard-card.vue?vue&type=template&id=08ea16e0&scoped=true&"
import script from "./sales-order-dashboard-card.vue?vue&type=script&lang=js&"
export * from "./sales-order-dashboard-card.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08ea16e0",
  null
  
)

export default component.exports